module.exports = __webpack_public_path__ + "img/game_main_pc_36_off.49c8975d.png";